module.exports = __webpack_public_path__ + "img/default2.d11f37ec.png";